<div class="p8-bdc_category__container" [routerLink]="['/page/', category.id]">
  <mat-icon class="">{{(category.data.icon) ? category.data.icon : 'account_balance'}}</mat-icon>
  <div class="mat-subheading-2">{{ category.data.title }}</div>
</div>
